module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// ./~/rc-align/~/core-js/library/modules/_redefine.js
// module id = 510
// module chunks = 1